import { render, staticRenderFns } from "./LookApplyProducts.vue?vue&type=template&id=f4453714&scoped=true&"
import script from "./LookApplyProducts.vue?vue&type=script&lang=js&"
export * from "./LookApplyProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4453714",
  null
  
)

export default component.exports